import i18n from "@/i18n";
import { DeclarationData } from "../../data/declarationData";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { ContractsFilters } from "../../data/enums/contractsFilters";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { DeclarationPropertiesViews } from "../../data/enums/declarationPropertiesViews";
import { CardModel } from "../../models/contracts/cardModel";
import { ContractsTypes } from "../../data/enums/contractsTypes";
import { RequestsStates } from "../../data/enums/requestsStates";
import { OperationRequestData } from "../../data/operationRequestData";
import { Dictionary } from "../../data/types/index";
import { CardsStates } from "../../data/enums/cardsStates";
import currencyFilter from "../../filters/currency.filter";
import urlFilter from "../../filters/url.filter";
import { ContractModel } from "../contracts/contractModel";
import { ContractsModel } from "../contracts/contractsModel";
import { OperationModel } from "./operationModel";
import { OperationPropertyModel } from "./operationPropertyModel";
import { CatalogOperationTypes } from "../../data/enums/catalogOperationTypes";
import { ConfigStore } from "../../store/modules/config";
import router from "@/router";

/** Модель операции */
export class CatalogOperationModel extends OperationModel {
  /**Данные декларации. */
  public Declaration: DeclarationData = new DeclarationData();

  /**Реквизиты. */
  public Properties: Array<OperationPropertyModel> = [];

  /**Обработка assign */
  public AssignLoading!: boolean;

  /**Запустить prepare полсе assign */
  public PrepareAfterAssign!: boolean;

  public Contracts!: ContractsModel | null;

  public PrepareData!: Dictionary<string> | null;

  public catalogOperationType: CatalogOperationTypes = CatalogOperationTypes.Any;

  static urlViewContract: string | null = null;

  public TemplateId: number | null = 0;

  public TemplateName: string | null = "";

  public PayReplaceGmpState: number = 0;

  constructor(
    declaration: DeclarationData | null = null,
    contracts: ContractsModel | null = null,
    template: OperationRequestData | null = null,
    addInitData: Dictionary<string> = {},
    configStore: ConfigStore | null = null
  ) {
    super();
    if (!declaration) return;

    this.Declaration = declaration;
    this.RespondentCode = this.Declaration.Id.toString();
    // Инициализация реквизитов операции по ее декларации.
    for (const key in this.Declaration.Properties) {
      const prop = this.Declaration.Properties[key];
      const opm = new OperationPropertyModel(prop, configStore);

      opm.loadValues(contracts);

      opm.loadMasks();
      // if (template != null) {
      //   // Корректировка по шаблону.
      //   if (Object.keys(template.views).includes(prop.Name)) {
      //     prop.View = template.views[prop.Name];
      //   }
      //   const valKey = template.keys.indexOf(prop.Name);
      //   if (valKey >= 0) {
      //     prop.Default = template.values[valKey];
      //   }
      // }
      if (Object.keys(addInitData).includes(prop.Name)) {
        prop.Default = addInitData[prop.Name];
      }
      if (
        (prop.Default == null || prop.Default.trim() === "") &&
        prop.Type == DeclarationPropertiesTypes.UserAccount &&
        opm.Values &&
        (prop.Name.toLowerCase() === "contract" ||
          prop.Name.toLowerCase() === "contractto")
      ) {
        prop.Default = opm.Values[0]?.Key;
      }

      if(configStore?.phoneFormatDir?.Operations?.SBPC2C 
        && this.RespondentCode == configStore.apiData.OperationCodeOfSbpOperation
        && configStore.phoneFormatDir.Operations.SBPC2C.Field === prop.Name) {
            opm.IsPhone = true;

            configStore.phoneFormatDir.Operations.SBPC2C.Formats.forEach((f: string) => {
              if (configStore.phoneFormatDir.FormatDict[f]) {
                opm.RawPhoneFormats[f] = configStore.phoneFormatDir.FormatDict[f];
                opm.PhoneFormats.push(configStore.phoneFormatDir.FormatDict[f]);
              }
              
            });
      
            opm.SelectedPhoneFormat = opm.PhoneFormats[0];
      }
      
      if (prop.Default != null && prop.Default.trim() !== "") {
        opm.setProperty(prop.Default);
      }
      opm.loadCheckRules();

      

      this.Properties.push(opm);
    }
        //   Object.keys(addInitData)[0] !== undefined
        // ? Object.keys(addInitData)[0]
        // : "contract",
    this.Contracts = contracts;
    this.contractChange(
      addInitData["contractTo"] != undefined ? "contractTo" : "contract",
      contracts
    );
    this.setCurrencies();
    this.TemplateId = template?.templateId ?? 0;
    this.TemplateName = template?.templateName ?? "";

    
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData(null);
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;
    ord.templateId = this.TemplateId ?? 0;
    ord.templateName = this.TemplateName ?? "";

    this.Properties.forEach((prop: OperationPropertyModel) => {
      ord.setProperty(
        prop.Declaration.Name,
        prop.IsPhone && process.env.VUE_APP_NAME == 'FINSERV' ? `${prop.SelectedPhoneFormat.DisplayCode} ${prop.PhoneDisplayValue}` : prop.getProperty(),
        prop.Declaration.Type
      );
    });

    if (this.PayReplaceGmpState === 2) {
      ord.setProperty(
        'payWithoutReplaceGmp',
        true,
        DeclarationPropertiesTypes.Boolean
      );
    }
    
    ord.setProperty(
      "_source",
      "web",
      DeclarationPropertiesTypes.String
    );
    
    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(
    ord: OperationRequestData,
    bAssign: boolean,
    isTemplate: boolean = false
  ): void {
    if (!bAssign) this.OperationId = ord.operationId;

    let newCatalogIdStr: any = null;
    let initNewOperation: any = null;
    let payKind: any = null;

    if (ord.wasReplaceProps) {
      this.PayReplaceGmpState = 1;
    }

    if (ord.operationType)
      this.catalogOperationType = ord.operationType;

    if (Object.keys(ord.PrepareData).length > 0) {
      this.PrepareData = ord.PrepareData;
    } else {
      this.PrepareData = null;
    }

    const hasErrors  = Object.keys(ord.PropertyErrors).length > 0;
    const hasCaptions  = Object.keys(ord.Captions).length > 0;
    
    this.Properties.forEach((prop: OperationPropertyModel) => {
      const name = prop.Declaration.Name;
      if (!isTemplate) {
        if (name == "newCatalogId") {
          newCatalogIdStr = ord.getPropertyValue(name);
        }
        if (name == "initNewOperation") {
          initNewOperation = ord.getPropertyValue(name);
        }
        if (name == "payKind") {
          payKind = ord.getPropertyValue(name);
        }
        if (name == "viewContract") {
          let urlContract = ord.getPropertyValue(name);
          if (urlContract) {
            CatalogOperationModel.urlViewContract = urlContract;
          }
        }
      } 
      

      if (name == 'type') {
        const nameProp: OperationPropertyModel | undefined = this.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name == 'receiverName');
        const typeIndex: number = ord.keys.indexOf('type');
        if (nameProp) {
          if (ord.values[typeIndex] !== '' && ord.values[typeIndex] !== 'SBP' && ord?.listValues?.card?.length) {
            const recIndex: number = ord.keys.indexOf('receiverName');
            const value: string = ord.listValues.card[0].Value.split('|')[2] ? ord.listValues.card[0].Value.split('|')[2] : ord.values[recIndex];
            nameProp.Declaration.View = 1;
            nameProp.Value = value;
          } else if (ord?.listValues?.card?.length === 0) {
            nameProp.Declaration.View = 2;
          }
        }
      }

      if (Object.keys(ord.imageProps).includes(name)) {
        if (bAssign || isTemplate) {
          prop.Declaration.imageSource = ord.imageProps[name];
          prop.Declaration.Image = true;
        }
      }

      if (Object.keys(ord.views).includes(name)) {
        if (bAssign) prop.Declaration.View = ord.views[name];
        else prop.ConfirmView = ord.views[name];
      } else prop.ConfirmView = prop.Declaration.View;

      if (
        prop.Declaration.ListType.trim() !== "" &&
        Object.keys(ord.listDefaults).includes(name)
      ) {
        prop.Value = null;
        prop.Values = [];

        if (
          prop.Declaration.Default.trim() !== "" &&
          Object.keys(prop.Declaration.Values).includes(
            prop.Declaration.Default
          )
        ) {
          const dpv = prop.Declaration.Values[prop.Declaration.Default];
          prop.Values.push(
            new DeclarationPropertyValueData(
              prop.Declaration.Default,
              dpv.Value,
              dpv.Image
            )
          );
        }

        const listDef = ord.listDefaults[name];
        if (Object.keys(prop.Declaration.Values).includes(listDef)) {
          const dpv = prop.Declaration.Values[listDef];
          prop.Values.push(
            new DeclarationPropertyValueData(
              listDef,
              `${dpv.Value} ${i18n
                .t("main.operation.form.default")
                .toString()}`,
              dpv.Image
            )
          );
        }

        for (const key in prop.Declaration.Values) {
          const dKV = prop.Declaration.Values[key];
          if (dKV.Key != listDef && dKV.Key != prop.Declaration.Default) {
            prop.Values.push(
              new DeclarationPropertyValueData(dKV.Key, dKV.Value, dKV.Image)
            );
          }
        }
      }

      if (
        prop.Declaration.ListType.trim() !== "" &&
        Object.keys(ord.listValues).includes(name)
      ) {
        prop.Value = null;
        prop.Values = [];

        for (const key in ord.listValues[name]) {
          if (process.env.VUE_APP_NAME == 'FINSERV') {
            const item: any = this.parseListValue(name, ord.listValues[name][key].Value);
            if(item)
            prop.Values.push(
              new DeclarationPropertyValueData(
                item.key,
                item.value,
                item.image,
                item.attribute
              )
            );
          } else {
            prop.Values.push(ord.listValues[name][key]);
          }
        }

        // if(prop.Values.length > 0) {
        //   prop.Value = prop.Values[0].Key;
        // }
      }

      if (
        prop.Declaration.Type == DeclarationPropertiesTypes.UserAccount &&
        Object.keys(ord.filters).includes(name)
      ) {
        var filter = ord.filters[name] || 0;
        if(prop.Declaration.Filter != filter) {
          prop.Declaration.Filter = filter;
          prop.loadValues(this.Contracts);
        }
      }

      prop.errorText = hasErrors ? ord.PropertyErrors[name] ?? "" : "";
      if(hasCaptions && Object.keys(ord.Captions).includes(name))
        prop.Declaration.Caption = ord.Captions[name];

      prop.setProperty(ord.getPropertyValue(name), ord.respondentCode);
    });

    if (Object.keys(ord.assignDescription).includes("<common>")) {
      this.Declaration.Description = ord.assignDescription["<common>"];
    }

    const newCatalogId = parseInt(newCatalogIdStr)
    if (initNewOperation == "1" && !isNaN(newCatalogId)) {
      const addInitData: Array<string> = [];

      this.Properties.forEach((prop: OperationPropertyModel) => {
        addInitData.push(`${prop.Declaration.Name}=${prop.Declaration.Name == "payKind" && payKind ? payKind : prop.getProperty()}`);
      });

      router.push(`/operation/0/${newCatalogId}?${addInitData.join('&')}`)
    }
    this.setCurrencies(ord);
  }

  /**Обработка смены счета */
  public contractChange(name: string, contracts: ContractsModel | null): void {
    name = name.toLocaleLowerCase();
    const contractChanged = this.Properties.find(
      (p: OperationPropertyModel) => {
        return (
          p.Declaration.Type == DeclarationPropertiesTypes.UserAccount &&
          p.Declaration.Name.toLocaleLowerCase() == name
        );
      }
    );
    const contractAnother = this.Properties.find(
      (p: OperationPropertyModel) => {
        return (
          p.Declaration.Type == DeclarationPropertiesTypes.UserAccount &&
          p.Declaration.Name.toLocaleLowerCase() ==
            (name == "contract" ? "contractto" : "contract")
        );
      }
    );
    // const cardSelector: OperationPropertyModel = this.Properties.find((p: OperationPropertyModel) => {
    //   return (
    //     p.Declaration.Type == DeclarationPropertiesTypes.CardSelector &&
    //     p.Declaration.Name.toLocaleLowerCase() == 'card'
    //   ); 
    // });

    // if (cardSelector && contractChanged) {
    //   cardSelector.Values = [];
    //   const unsortedAccs: Array<any> = this.Contracts.Contracts ?? contracts.Contracts;
    //   const accounts = unsortedAccs
    //     .filter((x: ContractModel) => {
    //       return (
    //         x.Data.ContractType != ContractsTypes.CreditAccount
    //       );
    //     });
    //   accounts.forEach((ac: ContractModel) => {
    //     if (contractChanged.Value.Key !== ac.Data.ReferenceId) {
    //       ac.Cards.forEach((c: CardModel) => {
    //         if(c.Data.CardState == CardsStates.Active) {
    //           const cardValue: string = `${c.CardPlasticTypeTitle} ${c.ShortCardNumber.substring(2)} - ${ac.DisposableLimit} ${ac.Currency}`;
    //           cardSelector.Values.push(new DeclarationPropertyValueData(c.Data.ReferenceId, cardValue, ''));
    //         }
    //       });
    //     }
    //   });
    //   accounts.forEach((ac: ContractModel) => {
    //     if (contractChanged.Value.Key == ac.Data.ReferenceId) {
    //       ac.Cards.forEach((c: CardModel) => {
    //         const cardValue: string = cardSelector.Value && cardSelector.Value.Key ? cardSelector.Value.Key.split(' ').join('') : cardSelector.Value?.split(' ').join('');
    //         if(c.Data.ReferenceId == cardValue) {
    //           cardSelector.Value = '';
    //         }
    //       });
    //     }
    //   });
    // }

    if (!contractChanged || !contractAnother) return;

    // contractAnother.Values.map((item) => {
    //   if (item.Key === contractChanged.Value.Key) {
    //     item.Hidden = true;
    //   } else
    //     item.Hidden = false;
    // });

    if (
      contractChanged.Value &&
      contractAnother.Value &&
      contractChanged.Value.Key == contractAnother.Value.Key
    ) {
      let tempIndex = contractAnother.Values.indexOf(contractAnother.Value);
      if (tempIndex + 1 == contractAnother.Values.length) tempIndex = 0;
      else tempIndex++;

      contractAnother.Value = contractAnother.Values[tempIndex];
    }

    if (contracts) this.setCurrencies();
  }

  /**Установка связанных валют */
/**Установка связанных валют */
public setCurrencies(ord: OperationRequestData = null): void {
  this.Properties.forEach((prop: OperationPropertyModel) => {
    if (prop.Declaration.CurrencyFrom) {
      prop.CurrensySymbol = "";
      const cp = this.Properties.find(
        c => c.Declaration.Name === prop.Declaration.CurrencyFrom
      );
      if (cp) {
        if (cp.Declaration.Name == "card") {
          if (cp.Value && cp.Value.Key) {
            const cardParts: string[] = cp.Value.Key.split('|');
            const acntNum: string = cardParts[cardParts.length - 1];
            if (acntNum)
              prop.CurrensySymbol = currencyFilter(acntNum.substring(5, 8));
          } else if (cp.Value && ord && ord.keys.find((key: string) => key === 'currencyTo')) {
              const index: number = ord.keys.indexOf('currencyTo');
              prop.CurrensySymbol = currencyFilter(ord.values[index]);
          }
        } else {
          const accounts: Array<ContractModel> = this.Contracts.getContractsByFilter(
            cp.Declaration.Filter as ContractsFilters
          );
          const curCntr = accounts.find(
            (c: ContractModel) => cp.Value && c.Data.ReferenceId == cp.Value.Key
          );
          if (curCntr) {
            prop.CurrensySymbol = currencyFilter(curCntr.Data.CurrencyCharCode);
          }
        }
      }
    }
  });
}

  /**
   * Проверка реквизитов
   * @returns Результат проверк true/false
   */
  public checkProperties(): boolean {
    let isValid = true;
    this.Properties.forEach((p: OperationPropertyModel) => {
      const result = p.check();
      if (p.check() !== true) {
        isValid = false;
        return;
      }
    });

    return isValid;
  }

  /**Детели операции */
  get details(): Array<any> {
    const details: Array<any> = [];

    this.Properties.forEach((item: OperationPropertyModel) => {
      if (item.ConfirmView !== DeclarationPropertiesViews.Hidden) {
        details.push({
          name: item.Declaration.Caption,
          textVal: item.DisplayValue
        });
      }
    });

    return details;
  }

  public parseListValue(propKey: string, value: string): any {
    if (propKey == "type") {
      const valArr: Array<string> = value.split("|")
      const key: string = valArr[0] ?? ""
      const val: string = valArr[1] ?? ""
      const img: string = valArr[2] ?? ""
      return { key: key, value: val, image: urlFilter(img) }
    } else if (propKey == "card") {
      const valArr: Array<string> = value.split("|")
      const key: string = valArr[1] ?? "";
      const name: string = valArr[2] ?? "";
      const servAcc: string = valArr[3] ?? "";
      let val = "";
      if(value) {
        const cardMod: CardModel = new CardModel();
        cardMod.Data.Number = key;
        val = `${cardMod.CardPlasticTypeTitle} *${key.substring(key.length-4, key.length)}`  // `${FsHelper.cardNumberFormat(valArr[1])} ${valArr[2]}`
        let acc;
        acc = this.Contracts.Contracts.find((acc: any) => acc.Cards.find((card: any) => card.Data.ReferenceId == key) ? true : false);
        if (acc)
          val += ` - ${acc.DisposableLimit} ${acc.Currency}`;
        else
          val += ` ${currencyFilter(servAcc.substring(5,8))}`;
      }
      return value ? { key: value, value: val, image: "", attribute: name } : null;
    } else {
      return { key: value, value: value, image: "" }
    }
  }
}
